export default __webpack_public_path__ + "static/media/Accenture.ce07befb.svg";